/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export { Directory } from "./Directory.section";
export type { DirectoryProps } from "./Directory.section";
export { DirectoryCard } from "./grid/DirectoryCard";
export type {
	DirectoryCardProps,
	DirectoryCardBadge,
	DirectoryCardLogo,
	DirectoryCardMetaItem,
	DirectoryCardTone,
	DirectoryCardHeadingLevel,
} from "./grid/DirectoryCard";
export { DirectoryHeading } from "./chrome/DirectoryHeading.element";
export type { DirectoryHeadingProps } from "./chrome/DirectoryHeading.element";
export { DirectorySection } from "./chrome/DirectorySection.element";
export type { DirectorySectionProps } from "./chrome/DirectorySection.element";
export { DirectorySpotlight } from "./DirectorySpotlight";
export type { DirectorySpotlightProps } from "./DirectorySpotlight";
// `useDirectoryRouter` is an internal SSR-safe shim used only by
// `useDirectory`; not re-exported (no external consumers).
export { useDirectory } from "./core/Directory.hook";
// `DirectoryContext` is intentionally NOT re-exported — consuming the raw
// context with `useContext` gives back `unknown[]` (the generic is erased
// at the context boundary). Use the typed hooks below.
export {
	useCurrentSearchQuery,
	useDirectoryConfig,
	useDirectoryContext,
	useDirectoryItems,
} from "./core/Directory.context";
export type {
	DirectoryConfig,
	DirectoryContextValue,
	DirectoryGridRenderProp,
	DirectoryState,
	FilterDef,
	FilterOption,
	NumberAccessor,
	PaginationConfig,
	SearchAccessor,
	SortConfig,
	SortOption,
	StringAccessor,
	StringListAccessor,
	UseDirectoryResult,
} from "./core/Directory.types";
// Slot prop types — re-exported for typed wrappers (e.g. an `InstructorDirectory`
// component that thin-wraps `<Directory>` and forwards a subset of props).
export type { DirectoryGridProps, DirectoryGridColumns } from "./grid/DirectoryGrid.molecule";
export type { DirectoryNoResultsProps } from "./grid/DirectoryNoResults.element";
// `Directory.utils` (applyFilters / applySort / encode / parse / sliceForPage)
// stays internal — consumers should compose via the `Directory` section or
// `useDirectory` hook rather than reaching for the engine directly. The
// `deriveOptions` helper is the one public utility — consumers commonly need
// to derive chip/combobox options from their own data shape.
export { deriveOptions } from "./core/Directory.utils";
